import { DocumentNode, gql } from '@apollo/client';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';

// TODO: replace with DataQualityCertificationFragment when feature flag is gone
export const TableCertificationFragmentGql: DocumentNode = gql`
fragment TableCertification on DatabaseTable {
  isCertified
  certificationNote
  certifier {
    ...TableauUser
  }
}
${TableauUserFragmentGql}
`;
